import { Box, Button, Grid, Typography, Tooltip } from "@mui/material";
import React from "react";

export default function Application({
  imgSrc,
  label,
  subText,
  url,
  navigateTo,
  tooltipText,
  tooltipBgColor,
  tooltipPlacement = "top",
  tooltipFontSize = "12px",
  tooltipWidth = "auto",
}) {
  return (
    <Grid item xs={3} md={3}>
      <Box className="dvGroup" onClick={(event) => navigateTo(url, event)}>
        <Tooltip
          title={tooltipText}
          placement={tooltipPlacement}
          arrow
          componentsProps={{
            tooltip: {
              sx: {
                backgroundColor: tooltipBgColor || "rgba(97, 97, 97, 0.9)",
                color: "#fff",
                fontSize: tooltipFontSize,
                padding: "6px 10px",
                borderRadius: "8px",
                width: tooltipWidth,
                textAlign: "center",
              },
            },
            arrow: {
              sx: {
                color: tooltipBgColor || "rgba(97, 97, 97, 0.9)",
              },
            },
          }}
        >
          <Button data-testid={label} variant="text">
            <img className="imgIconCenter" src={imgSrc} alt={label} />
          </Button>
        </Tooltip>

        <Typography className="landingColorText22">{label}</Typography>
        <Typography className="landingColorSubText">{subText}</Typography>
      </Box>
    </Grid>
  );
}
